import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import './css/ViewNoticia.css';
import { getDatabase, ref, get } from 'firebase/database';
import firebaseApp, { KEY_REF } from './adm/admin/firebaseConfig';
import SecretaryCard from '../componentes/utils/SecretaryCard';
import DataTable from '../componentes/utils/Tabela';
import { Box, Card, CardContent, Divider, Tabs, Tab, Typography } from '@mui/material';

const db = getDatabase(firebaseApp);

// Custom TabPanel component for accessibility
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vereador-tabpanel-${index}`}
      aria-labelledby={`vereador-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: { xs: 2, md: 3 } }}>
          {children}
        </Box>
      )}
    </div>
  );
}

export default function ViewVereador() {
  const [isLoading, setIsLoading] = useState(true);
  const [noticias, setNoticias] = useState({});
  const [formattedDate, setFormattedDate] = useState('Carregando...');
  const [requerimentos, setRequerimentos] = useState([]);
  const [projetosDeLei, setProjetosDeLei] = useState([]);
  const [indicacoes, setIndicacoes] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  const { id } = useParams();
  const noticiasRef = ref(db, `vereadores/${id}`);
  const requerimentosRef = ref(db, `requerimentos`);
    const projetosDeLeiRef = ref(db, `projetodelei`);
    const indicacoesRef = ref(db, `indicacoes`);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch vereador data
        const vereadorSnapshot = await get(noticiasRef);
        let vereadorName = '';
        if (vereadorSnapshot.exists()) {
          const noticiaData = vereadorSnapshot.val();
          vereadorName = noticiaData.nome;

          // Format date
          const parsedDate = new Date(noticiaData.data);
          if (!isNaN(parsedDate)) {
            const formattedDate = format(parsedDate, 'dd/MM/yyyy');
            setFormattedDate(formattedDate);
          }

          setNoticias({
            nome: noticiaData.nome,
            descricao: noticiaData.descricao,
            partido: noticiaData.partido,
            imagem: noticiaData.documentoUrl,
            email: noticiaData.email,
            horario: noticiaData.horario,
            telefone: noticiaData.telefone
          });
        }

        // Fetch requerimentos
        const requerimentosSnapshot = await get(requerimentosRef);
        if (requerimentosSnapshot.exists()) {
          const reqData = requerimentosSnapshot.val();
          const reqArray = Object.keys(reqData)
            .filter(key => reqData[key].vereador === vereadorName)
            .map(key => ({
              id: key,
              title: reqData[key].nome,
              numero: reqData[key].numero || null,
              mes: reqData[key].mes,
              dia: reqData[key].dia || null,
              ano: reqData[key].ano,
              href: reqData[key].href,
              vereador: reqData[key].vereador
            }));
          setRequerimentos(reqArray);
        }

        // Fetch projetos de lei
        const projetosSnapshot = await get(projetosDeLeiRef);
        if (projetosSnapshot.exists()) {
          const projData = projetosSnapshot.val();
          const projArray = Object.keys(projData)
            .filter(key => projData[key].vereador === vereadorName)
            .map(key => ({
              id: key,
              title: projData[key].nome,
              numero: projData[key].numero || null,
              mes: projData[key].mes,
              dia: projData[key].dia || null,
              ano: projData[key].ano,
              href: projData[key].href,
              vereador: projData[key].vereador
            }));
          setProjetosDeLei(projArray);
        }

            const indicacoesSnapshot = await get(indicacoesRef);
        if (indicacoesSnapshot.exists()) {
          const indData = indicacoesSnapshot.val();
          const indArray = Object.keys(indData)
            .filter(key => indData[key].vereador === vereadorName)
            .map(key => ({
              id: key,
              title: indData[key].nome,
              numero: indData[key].numero || null,
              mes: indData[key].mes,
              dia: indData[key].dia || null,
              ano: indData[key].ano,
              href: indData[key].href,
              vereador: indData[key].vereador
            }));
          setIndicacoes(indArray);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const secretario = {
    nome: noticias.nome,
    descricao: noticias.descricao,
    foto: noticias.imagem,
    imagem: noticias.imagem,
    telefone: noticias.telefone || "(83) 0000-0000",
    email: noticias.email || 'sem endereço de e-mail informado',
    horario: noticias.horario || "08h às 14h - Segunda a Sexta-Feira",
    cargo: noticias.partido,
    page: `Vereador(a) ${noticias.nome}`,
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  return (
    <Box sx={{ 
      padding: { xs: 2, sm: 3, md: 4 }, 
      maxWidth: '1200px', 
      mx: 'auto', 
      display: 'flex', 
      flexDirection: 'column', 
      gap: 3 
    }}>
      <SecretaryCard {...secretario} />
      <Divider sx={{ my: 2, bgcolor: 'grey.300' }} />
      <Card sx={{ 
        boxShadow: 2, 
        borderRadius: 2, 
        bgcolor: 'background.paper'
      }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="fullWidth"
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            '.MuiTab-root': {
              textTransform: 'none',
              fontWeight: 'medium',
              fontSize: { xs: '0.9rem', sm: '1rem' },
              padding: { xs: '8px', sm: '12px' },
            },
            '.Mui-selected': {
              color: 'primary.main',
              fontWeight: 'bold',
            },
            '.MuiTabs-indicator': {
              backgroundColor: 'primary.main',
            },
          }}
          aria-label="vereador documents tabs"
        >
          <Tab label="Requerimentos" id="vereador-tab-0" aria-controls="vereador-tabpanel-0" />
          <Tab label="Projetos de Lei" id="vereador-tab-1" aria-controls="vereador-tabpanel-1" />
          <Tab label="Indicações"       id="vereador-tab-2" aria-controls="vereador-tabpanel-2" /> 
        </Tabs>
       <CardContent sx={{ p: 0 }}>
          <TabPanel value={tabValue} index={0}>
            {requerimentos.length > 0 ? (
              <DataTable data={requerimentos} itemtype="requerimentos" />
            ) : (
              <Typography variant="body2" color="text.secondary" align="center">
                Nenhum requerimento encontrado.
              </Typography>
            )}
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            {projetosDeLei.length > 0 ? (
              <DataTable data={projetosDeLei} itemtype="projetodelei" />
            ) : (
              <Typography variant="body2" color="text.secondary" align="center">
                Nenhum projeto de lei encontrado.
              </Typography>
            )}
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            {indicacoes.length > 0 ? (
              <DataTable data={indicacoes} itemtype="indicacoes" />   
            ) : (
              <Typography variant="body2" color="text.secondary" align="center">
                Nenhuma indicação encontrada para este vereador.
              </Typography>
            )}
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
}